(function () {
  'use strict';

  var activeController = null;
  var initializationQueued = false;
  var lockedScrollY = null;
  var previousBodyTop = '';

  function getOpenDrawer() {
    return document.querySelector('#t4s-mini_cart[aria-hidden="false"]');
  }

  function lockPageScroll() {
    if (lockedScrollY !== null) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    previousBodyTop = document.body.style.top;
    document.body.style.top = '-' + lockedScrollY + 'px';
    document.documentElement.classList.add('cd-mini-cart-open');
    document.body.classList.add('cd-mini-cart-open');
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('cd-mini-cart-open');
    document.body.classList.remove('cd-mini-cart-open');
    if (lockedScrollY === null) return;

    var scrollY = lockedScrollY;
    document.body.style.top = previousBodyTop;
    lockedScrollY = null;
    previousBodyTop = '';
    window.scrollTo(0, scrollY);
  }

  function syncPageScroll() {
    if (getOpenDrawer()) lockPageScroll();
    else unlockPageScroll();
  }

  function containPointerScroll(event) {
    var drawer = getOpenDrawer();
    if (!drawer) return;

    var modal = document.querySelector('[data-cd-cart-addon-modal]:not([hidden])');
    var allowedTarget = modal && modal.contains(event.target)
      ? modal.querySelector('.cd-cart-addon-modal__panel')
      : drawer.querySelector('[data-cd-cart-scroll]');

    if (allowedTarget && allowedTarget.contains(event.target)) {
      event.stopPropagation();
      return;
    }

    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
  }

  function containKeyboardScroll(event) {
    var drawer = getOpenDrawer();
    if (!drawer) return;
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(event.key) === -1) return;
    if (event.target.matches('input, select, textarea')) return;

    var modal = document.querySelector('[data-cd-cart-addon-modal]:not([hidden])');
    var isInsideScrollableArea = (modal && modal.contains(event.target)) || drawer.contains(event.target);
    if (!isInsideScrollableArea && event.cancelable) event.preventDefault();
    event.stopPropagation();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function createController(root) {
    var abortController = new AbortController();
    var signal = abortController.signal;
    var outerDrawer = root.closest('#t4s-mini_cart');
    var itemsContainer = root.querySelector('[data-cd-cart-items]');
    var recommendationsSection = root.querySelector('[data-cd-cart-recommendations]');
    var recommendationsTrack = root.querySelector('[data-cd-cart-recommendations-track]');
    var recommendationsPrevious = root.querySelector('[data-cd-cart-recommendations-previous]');
    var recommendationsNext = root.querySelector('[data-cd-cart-recommendations-next]');
    var addonModal = root.querySelector('[data-cd-cart-addon-modal]');
    var addonForm = addonModal && addonModal.querySelector('[data-cd-cart-addon-form]');
    var addonTitle = addonModal && addonModal.querySelector('[data-cd-cart-addon-title]');
    var addonPrice = addonModal && addonModal.querySelector('[data-cd-cart-addon-price]');
    var addonImageWrap = addonModal && addonModal.querySelector('[data-cd-cart-addon-image-wrap]');
    var addonOptions = addonModal && addonModal.querySelector('[data-cd-cart-addon-options]');
    var addonPurchaseOptions = addonModal && addonModal.querySelector('[data-cd-cart-addon-purchase-options]');
    var addonOneTimeOption = addonModal && addonModal.querySelector('[data-cd-cart-addon-one-time-option]');
    var addonOneTimePrice = addonModal && addonModal.querySelector('[data-cd-cart-addon-one-time-price]');
    var addonSubscriptionPrice = addonModal && addonModal.querySelector('[data-cd-cart-addon-subscription-price]');
    var addonPlanDetails = addonModal && addonModal.querySelector('[data-cd-cart-addon-plan-details]');
    var addonPlanSelect = addonModal && addonModal.querySelector('[data-cd-cart-addon-selling-plan]');
    var addonPlanDescription = addonModal && addonModal.querySelector('[data-cd-cart-addon-plan-description]');
    var addonQuantity = addonModal && addonModal.querySelector('[data-cd-cart-addon-quantity]');
    var addonSubmit = addonModal && addonModal.querySelector('[data-cd-cart-addon-submit]');
    var addonAvailability = addonModal && addonModal.querySelector('[data-cd-cart-addon-availability]');
    var protectionRow = root.querySelector('[data-cd-cart-protection]');
    var protectionToggle = root.querySelector('[data-cd-cart-protection-toggle]');
    var protectionPrice = root.querySelector('[data-cd-cart-protection-price]');
    var checkoutButton = root.querySelector('[data-cd-cart-checkout]');
    var loadingBackground = root.querySelector('[data-cd-cart-loading]');
    var statusNode = root.querySelector('[data-cd-cart-status]');
    var sectionId = root.dataset.sectionId || 'mini_cart';
    var moneyFormat = root.dataset.moneyFormat || (window.T4Sconfigs && window.T4Sconfigs.moneyFormat) || '${{amount}}';
    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var recommendationData = extractRecommendationData(root);
    var protectionConfig = extractProtectionConfig(root);
    var protectionVariantSet = new Set(protectionConfig.tiers.map(function (tier) { return tier.id; }));
    var currentCart = null;
    var refreshTimer = null;
    var refreshPromise = null;
    var refreshAgain = false;
    var reloadRecommendationsNext = false;
    var busyCount = 0;
    var renderedRecommendations = new Map();
    var activeAddonProduct = null;
    var activeAddonVariant = null;
    var addonPurchaseMode = 'one_time';
    var addonSellingPlanId = '';
    var addonError = '';
    var addonReturnFocus = null;
    var recommendationGesture = null;
    var suppressRecommendationClick = false;

    root.dataset.cdCartReady = 'true';
    if (outerDrawer) outerDrawer.classList.add('cd-cart-drawer-host');
    if (addonModal) document.body.appendChild(addonModal);

    function route(path) {
      return shopRoot.replace(/\/?$/, '/') + path.replace(/^\//, '');
    }

    function formatMoney(cents) {
      var value = Number(cents || 0);
      var placeholderRegex = /{{\s*(\w+)\s*}}/;
      var match = moneyFormat.match(placeholderRegex);
      var placeholder = match ? match[1] : 'amount';

      function withDelimiters(amount, precision, thousands, decimal) {
        var number = (amount / 100).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        return dollars + (parts[1] ? decimal + parts[1] : '');
      }

      var formatted;
      switch (placeholder) {
        case 'amount_no_decimals':
          formatted = withDelimiters(value, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          formatted = withDelimiters(value, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formatted = withDelimiters(value, 0, '.', ',');
          break;
        default:
          formatted = withDelimiters(value, 2, ',', '.');
          break;
      }

      return match ? moneyFormat.replace(placeholderRegex, formatted) : '$' + formatted;
    }

    function extractRecommendationData(context) {
      var sources = new Map();
      if (!context) return sources;

      context.querySelectorAll('[data-cd-cart-recommendation-source]').forEach(function (source) {
        var sourceProductId = String(source.dataset.sourceProductId || '');
        var products = sources.get(sourceProductId) || [];

        source.querySelectorAll('[data-cd-cart-recommendation]').forEach(function (node) {
          try {
            var product = JSON.parse(node.textContent || '{}');
            product.id = String(product.id || '');
            product.title = product.title || '';
            product.url = product.url || '#';
            product.image = product.image || '';
            product.hasOnlyDefaultVariant = Boolean(product.has_only_default_variant);
            product.requiresSellingPlan = Boolean(product.requires_selling_plan);
            product.options = Array.isArray(product.options) ? product.options : [];
            product.variants = (Array.isArray(product.variants) ? product.variants : []).map(function (variant) {
              return {
                id: String(variant.id || ''),
                title: variant.title || '',
                available: Boolean(variant.available),
                price: Number(variant.price || 0),
                requiresSellingPlan: product.requiresSellingPlan || Boolean(variant.requires_selling_plan),
                sellingPlans: (Array.isArray(variant.selling_plans) ? variant.selling_plans : []).map(function (plan) {
                  return {
                    id: String(plan.id || ''),
                    name: plan.name || 'Subscription',
                    description: plan.description || '',
                    price: Number(plan.price || 0),
                    requiresBundle: Boolean(plan.requires_bundle)
                  };
                }).filter(function (plan) { return plan.id; }),
                options: Array.isArray(variant.options) ? variant.options : [],
                image: variant.image || product.image
              };
            });
            products.push(product);
          } catch (error) {
            console.warn('Cleerdent cart drawer: could not parse a recommended product.', error);
          }
        });

        sources.set(sourceProductId, products);
      });

      return sources;
    }

    function extractProtectionConfig(context) {
      var fallback = { thresholds: [10000, 100000], tiers: [] };
      var node = context && context.querySelector('[data-cd-cart-protection-tiers]');
      if (!node) return fallback;

      try {
        var data = JSON.parse(node.textContent || '{}');
        return {
          thresholds: (Array.isArray(data.thresholds) ? data.thresholds : fallback.thresholds).map(Number),
          tiers: (Array.isArray(data.tiers) ? data.tiers : []).map(function (tier) {
            return { id: String(tier.id || ''), price: Number(tier.price || 0) };
          }).filter(function (tier) { return tier.id; }).sort(function (left, right) {
            return left.price - right.price;
          })
        };
      } catch (error) {
        console.warn('Cleerdent cart drawer: could not parse shipping protection settings.', error);
        return fallback;
      }
    }

    function getProtectionTier(subtotal) {
      var tiers = protectionConfig.tiers;
      if (tiers.length === 0) return null;
      if (tiers.length === 1 || subtotal <= protectionConfig.thresholds[0]) return tiers[0];
      if (tiers.length === 2 || subtotal <= protectionConfig.thresholds[1]) return tiers[1];
      return tiers[2];
    }

    function isProtectionItem(item) {
      return protectionVariantSet.has(String(item.variant_id));
    }

    function getMerchandiseItems(cart) {
      return (cart && cart.items ? cart.items : []).filter(function (item) {
        return !isProtectionItem(item);
      });
    }

    function getMerchandiseSubtotal(cart) {
      return getMerchandiseItems(cart).reduce(function (sum, item) {
        return sum + Number(item.final_line_price == null ? item.line_price : item.final_line_price);
      }, 0);
    }

    function getVisibleItemCount(cart) {
      return getMerchandiseItems(cart).reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);
    }

    async function parseJsonResponse(response) {
      var data;
      try {
        data = await response.json();
      } catch (error) {
        data = null;
      }

      if (!response.ok) {
        throw new Error((data && (data.description || data.message)) || 'Unable to update the cart.');
      }
      return data;
    }

    async function fetchCart() {
      var response = await window.fetch(route('cart.js'), {
        headers: { Accept: 'application/json' }
      });
      return parseJsonResponse(response);
    }

    async function changeCartItem(key, quantity) {
      var response = await window.fetch(route('cart/change.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Cleerdent-Cart-Drawer': '1'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      return parseJsonResponse(response);
    }

    async function addCartVariant(variantId, properties, quantity, sellingPlanId) {
      var item = {
        id: Number(variantId),
        quantity: Math.max(1, Number(quantity) || 1)
      };
      if (properties) item.properties = properties;
      if (sellingPlanId) item.selling_plan = Number(sellingPlanId);

      var response = await window.fetch(route('cart/add.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Cleerdent-Cart-Drawer': '1'
        },
        body: JSON.stringify({ items: [item] })
      });
      return parseJsonResponse(response);
    }

    async function loadRecommendationData() {
      var response = await window.fetch(route('?section_id=' + encodeURIComponent(sectionId) + '&_=' + Date.now()), {
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) return;

      var html = await response.text();
      var parsedDocument = new DOMParser().parseFromString(html, 'text/html');
      var nextRoot = parsedDocument.querySelector('[data-cd-cart-drawer]');
      if (nextRoot) recommendationData = extractRecommendationData(nextRoot);
    }

    function setBusy(isBusy) {
      busyCount = Math.max(0, busyCount + (isBusy ? 1 : -1));
      var busy = busyCount > 0;
      if (loadingBackground) loadingBackground.classList.toggle('is-active', busy);
      root.querySelectorAll('button, input, select').forEach(function (control) {
        if (control.closest('[data-drawer-close]')) return;
        control.disabled = busy;
      });
      if (addonModal) {
        addonModal.querySelectorAll('button, input, select').forEach(function (control) {
          if (control.closest('[data-cd-cart-addon-close]')) return;
          control.disabled = busy;
        });
      }
      if (!busy) {
        updateRecommendationControls();
        if (addonModal && !addonModal.hidden) renderAddonVariant();
        if (checkoutButton) checkoutButton.disabled = getMerchandiseItems(currentCart).length === 0;
      }
      root.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    function announce(message, isError) {
      if (!statusNode) return;
      statusNode.textContent = message || '';
      statusNode.classList.toggle('is-error', Boolean(isError));
    }

    function getPairedSubscriptionItem(item, items) {
      var properties = item.properties || {};
      var role = properties._cd_bundle_role;
      if (role !== 'main' && role !== 'addon') return null;

      var pairFields = [
        '_cd_bundle_token', '_cd_bundle_main_product_id', '_cd_bundle_main_plan_id',
        '_cd_bundle_addon_variant_id', '_cd_bundle_addon_plan_id'
      ];
      if (pairFields.some(function (field) { return !properties[field]; })) return null;

      return items.find(function (candidate) {
        var candidateProperties = candidate.properties || {};
        if (candidateProperties._cd_bundle_role !== (role === 'main' ? 'addon' : 'main')) return false;
        if (!pairFields.every(function (field) {
          return String(properties[field]) === String(candidateProperties[field]);
        })) return false;

        var main = role === 'main' ? item : candidate;
        var addon = role === 'addon' ? item : candidate;
        var mainPlan = main.selling_plan_allocation && main.selling_plan_allocation.selling_plan;
        var addonPlan = addon.selling_plan_allocation && addon.selling_plan_allocation.selling_plan;
        return Boolean(mainPlan && addonPlan &&
          String(main.product_id) === String(properties._cd_bundle_main_product_id) &&
          String(mainPlan.id) === String(properties._cd_bundle_main_plan_id) &&
          String(addon.variant_id == null ? addon.id : addon.variant_id) === String(properties._cd_bundle_addon_variant_id) &&
          String(addonPlan.id) === String(properties._cd_bundle_addon_plan_id));
      });
    }

    function renderItems(cart) {
      if (!itemsContainer) return;
      var items = getMerchandiseItems(cart);
      if (items.length === 0) {
        itemsContainer.innerHTML = '<p class="cd-cart__empty">Your cart is empty.</p>';
        return;
      }

      itemsContainer.innerHTML = items.map(function (item) {
        var title = item.product_title || item.title || '';
        var image = item.image
          ? '<img class="cd-cart-item__image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(title) + '" loading="lazy">'
          : '';
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
          ? '<span class="cd-cart-item__variant">' + escapeHtml(item.variant_title) + '</span>'
          : '';
        var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
        var purchaseLabels = sellingPlan && sellingPlan.name ? [sellingPlan.name] : [];
        var pairedItem = getPairedSubscriptionItem(item, items);
        if (pairedItem) {
          // Subscription messaging belongs to the recurring add-on, not the paired device.
          if (item.properties._cd_bundle_role === 'main') {
            purchaseLabels = [];
          } else {
            var pairedPlanName = pairedItem.selling_plan_allocation.selling_plan.name;
            if (pairedPlanName && purchaseLabels.indexOf(pairedPlanName) === -1) purchaseLabels.unshift(pairedPlanName);
          }
        }
        var purchaseLabel = purchaseLabels.map(function (label) {
          return '<span class="cd-cart-item__variant">' + escapeHtml(label) + '</span>';
        }).join('');

        return '' +
          '<article class="cd-cart-item" data-cd-cart-item-key="' + escapeHtml(item.key) + '">' +
            '<a class="cd-cart-item__image-link" href="' + escapeHtml(item.url || '#') + '">' + image + '</a>' +
            '<div class="cd-cart-item__details">' +
              '<a class="cd-cart-item__title" href="' + escapeHtml(item.url || '#') + '">' + escapeHtml(title) + '</a>' +
              variantTitle +
              purchaseLabel +
            '</div>' +
            '<span class="cd-cart-item__price">' + formatMoney(item.final_line_price == null ? item.line_price : item.final_line_price) + '</span>' +
            '<div class="cd-cart-item__actions">' +
              '<div class="cd-cart-item__quantity" aria-label="Quantity for ' + escapeHtml(title) + '">' +
                '<button type="button" data-cd-cart-quantity="decrease" aria-label="Decrease quantity">−</button>' +
                '<span aria-live="polite">' + Number(item.quantity || 0) + '</span>' +
                '<button type="button" data-cd-cart-quantity="increase" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button class="cd-cart-item__remove" type="button" data-cd-cart-remove>Remove</button>' +
            '</div>' +
          '</article>';
      }).join('');
    }

    function collectRecommendations(cart) {
      var cartVariantIds = new Set((cart.items || []).map(function (item) {
        return String(item.variant_id);
      }));
      var seenProductIds = new Set();
      var recommendations = [];

      getMerchandiseItems(cart).forEach(function (item) {
        var products = recommendationData.get(String(item.product_id)) || [];
        products.forEach(function (product) {
          var hasUncartedAvailableVariant = product.variants.some(function (variant) {
            return variant.id && variant.available && !cartVariantIds.has(variant.id);
          });
          if (!product.id || !hasUncartedAvailableVariant || seenProductIds.has(product.id)) return;
          seenProductIds.add(product.id);
          recommendations.push(product);
        });
      });

      return recommendations;
    }

    function renderRecommendations(cart) {
      if (!recommendationsSection || !recommendationsTrack) return;
      var recommendations = collectRecommendations(cart);
      renderedRecommendations = new Map(recommendations.map(function (product) {
        return [product.id, product];
      }));
      recommendationsSection.hidden = recommendations.length === 0;

      recommendationsTrack.innerHTML = recommendations.map(function (product) {
        var image = product.image
          ? '<img class="cd-cart-recommendation__image" src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
          : '';
        var opensModal = needsAddonOptions(product);
        var action = opensModal ? 'Choose options for ' : 'Add ';
        var prices = [];
        product.variants.forEach(function (variant) {
          if (!variant.available) return;
          if (variant.requiresSellingPlan) {
            getStandalonePlans(variant).forEach(function (plan) { prices.push(plan.price); });
          } else {
            prices.push(variant.price);
          }
        });
        var minimumPrice = Math.min.apply(Math, prices);
        var price = prices.length ? (prices.some(function (value) { return value !== minimumPrice; }) ? 'From ' : '') + formatMoney(minimumPrice) : 'Unavailable';
        return '' +
          '<button class="cd-cart-recommendation" type="button" data-cd-cart-recommendation-product="' + escapeHtml(product.id) + '" aria-label="' + action + escapeHtml(product.title + ', ' + price) + '"' + (opensModal ? ' aria-haspopup="dialog"' : '') + '>' +
            '<span class="cd-cart-recommendation__image-wrap">' + image + '</span>' +
            '<span class="cd-cart-recommendation__title">' + escapeHtml(product.title) + '</span>' +
            '<span class="cd-cart-recommendation__price">' + price + '</span>' +
          '</button>';
      }).join('');

      recommendationsTrack.scrollLeft = 0;
      window.requestAnimationFrame(updateRecommendationControls);
    }

    function renderProtection(cart) {
      if (!protectionRow) return;
      var tier = getProtectionTier(getMerchandiseSubtotal(cart));
      var merchandiseItems = getMerchandiseItems(cart);
      var activeItem = (cart.items || []).find(isProtectionItem);
      protectionRow.hidden = !tier || merchandiseItems.length === 0;
      if (!tier) return;

      if (protectionToggle) protectionToggle.checked = Boolean(activeItem);
      if (protectionPrice) {
        var displayedPrice = activeItem
          ? Number(activeItem.final_line_price == null ? activeItem.line_price : activeItem.final_line_price)
          : tier.price;
        protectionPrice.textContent = formatMoney(displayedPrice);
      }
    }

    function updateGlobalCount(count) {
      document.querySelectorAll('[data-cart-count], .cart-count-bubble, .t4s-cart-count, .t4s-count-box').forEach(function (node) {
        node.textContent = count;
        node.classList.toggle('t4s-op-0', count === 0);
      });

      document.querySelectorAll('.cd-hero-header__cart-link').forEach(function (link) {
        var countNode = link.querySelector('.cd-hero-header__cart-count');
        if (count > 0 && !countNode) {
          countNode = document.createElement('span');
          countNode.className = 'cd-hero-header__cart-count';
          link.appendChild(countNode);
        }
        if (countNode) {
          countNode.textContent = count;
          countNode.hidden = count === 0;
        }
      });

      Array.from(document.documentElement.classList).forEach(function (className) {
        if (/^t4s-cart-count-\d+$/.test(className)) document.documentElement.classList.remove(className);
      });
      document.documentElement.classList.add('t4s-cart-count-' + count);
      if (outerDrawer) outerDrawer.dataset.ccount = String(count);
    }

    function renderTotals(cart) {
      var subtotal = root.querySelector('[data-cd-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      if (checkoutButton) checkoutButton.disabled = getMerchandiseItems(cart).length === 0;
      updateGlobalCount(getVisibleItemCount(cart));
    }

    function render(cart) {
      currentCart = cart;
      renderItems(cart);
      renderRecommendations(cart);
      renderProtection(cart);
      renderTotals(cart);
    }

    async function removeProtectionItems(cart) {
      var items = (cart.items || []).filter(isProtectionItem);
      var nextCart = cart;
      for (var index = 0; index < items.length; index += 1) {
        nextCart = await changeCartItem(items[index].key, 0);
      }
      return nextCart;
    }

    async function replaceProtection(cart, variantId) {
      var nextCart = await removeProtectionItems(cart);
      if (variantId) {
        await addCartVariant(variantId, { _cleerdent_shipping_protection: 'true' });
        nextCart = await fetchCart();
      }
      return nextCart;
    }

    async function syncProtectionTier(cart) {
      var protectionItems = (cart.items || []).filter(isProtectionItem);
      if (protectionItems.length === 0) return cart;
      var subtotal = getMerchandiseSubtotal(cart);
      if (subtotal <= 0) return removeProtectionItems(cart);

      var tier = getProtectionTier(subtotal);
      if (!tier) return removeProtectionItems(cart);
      if (protectionItems.length === 1 && String(protectionItems[0].variant_id) === tier.id && Number(protectionItems[0].quantity) === 1) {
        return cart;
      }
      return replaceProtection(cart, tier.id);
    }

    async function refresh(options) {
      options = options || {};
      reloadRecommendationsNext = reloadRecommendationsNext || Boolean(options.reloadRecommendations);
      if (refreshPromise) {
        refreshAgain = true;
        return refreshPromise;
      }

      refreshPromise = (async function () {
        do {
          refreshAgain = false;
          var shouldReloadRecommendations = reloadRecommendationsNext;
          reloadRecommendationsNext = false;
          if (shouldReloadRecommendations) await loadRecommendationData();
          var cart = await fetchCart();
          cart = await syncProtectionTier(cart);
          render(cart);
        } while (refreshAgain || reloadRecommendationsNext);
      })();

      try {
        await refreshPromise;
        announce('');
      } catch (error) {
        announce(error && error.message ? error.message : 'Unable to refresh the cart.', true);
      } finally {
        refreshPromise = null;
      }
    }

    function requestRefresh(reloadRecommendations) {
      reloadRecommendationsNext = reloadRecommendationsNext || Boolean(reloadRecommendations);
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(function () {
        refresh({ reloadRecommendations: reloadRecommendationsNext });
      }, 80);
    }

    async function runMutation(action, successMessage) {
      setBusy(true);
      announce('');
      try {
        await action();
        await loadRecommendationData();
        var cart = await fetchCart();
        cart = await syncProtectionTier(cart);
        render(cart);
        if (successMessage) announce(successMessage);
        document.dispatchEvent(new CustomEvent('cleerdent:cart:updated', { detail: { cart: cart } }));
        return true;
      } catch (error) {
        addonError = error && error.message ? error.message : 'Unable to update the cart.';
        announce(error && error.message ? error.message : 'Unable to update the cart.', true);
        await refresh({ reloadRecommendations: true });
        return false;
      } finally {
        setBusy(false);
      }
    }

    async function setProtection(selected) {
      await runMutation(async function () {
        var cart = await fetchCart();
        if (!selected) {
          await removeProtectionItems(cart);
          return;
        }
        var tier = getProtectionTier(getMerchandiseSubtotal(cart));
        if (tier) await replaceProtection(cart, tier.id);
      }, selected ? 'Shipping protection added.' : 'Shipping protection removed.');
    }

    function updateRecommendationControls() {
      if (!recommendationsTrack || !recommendationsPrevious || !recommendationsNext) return;
      var maximumScroll = Math.max(0, recommendationsTrack.scrollWidth - recommendationsTrack.clientWidth);
      recommendationsPrevious.disabled = recommendationsTrack.scrollLeft <= 2;
      recommendationsNext.disabled = recommendationsTrack.scrollLeft >= maximumScroll - 2 || maximumScroll === 0;
    }

    function scrollRecommendations(direction) {
      if (!recommendationsTrack) return;
      var card = recommendationsTrack.querySelector('.cd-cart-recommendation');
      var amount = card ? card.getBoundingClientRect().width + 10 : 114;
      recommendationsTrack.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    function getSelectedAddonVariant() {
      if (!activeAddonProduct || !addonOptions) return null;
      if (activeAddonProduct.hasOnlyDefaultVariant) return activeAddonProduct.variants[0] || null;
      var selectedOptions = Array.from(addonOptions.querySelectorAll('select')).map(function (select) {
        return select.value;
      });
      return activeAddonProduct.variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === selectedOptions[index];
        });
      }) || null;
    }

    function needsAddonOptions(product) {
      return product.variants.length > 1 || product.variants.some(function (variant) {
        return variant.requiresSellingPlan || variant.sellingPlans.length > 0;
      });
    }

    function getStandalonePlans(variant) {
      // The bundle guard removes free-first plans unless they have a paired product.
      return variant ? variant.sellingPlans.filter(function (plan) { return !plan.requiresBundle; }) : [];
    }

    function getSelectedAddonPlan() {
      if (addonPurchaseMode !== 'subscription') return null;
      return getStandalonePlans(activeAddonVariant).find(function (plan) {
        return plan.id === addonSellingPlanId;
      }) || null;
    }

    function renderAddonPurchaseOptions() {
      var plans = getStandalonePlans(activeAddonVariant);
      var requiresPlan = Boolean(activeAddonVariant && activeAddonVariant.requiresSellingPlan);
      if (requiresPlan) addonPurchaseMode = 'subscription';
      else if (!plans.length) addonPurchaseMode = 'one_time';
      if (!plans.some(function (plan) { return plan.id === addonSellingPlanId; })) {
        addonSellingPlanId = plans.length ? plans[0].id : '';
      }
      var selectedPlan = plans.find(function (plan) { return plan.id === addonSellingPlanId; });
      var hasSubscription = Boolean(activeAddonVariant && activeAddonVariant.sellingPlans.length);
      if (addonPurchaseOptions) addonPurchaseOptions.hidden = !hasSubscription && !requiresPlan;
      if (addonOneTimeOption) addonOneTimeOption.hidden = requiresPlan;
      if (addonOneTimePrice) addonOneTimePrice.textContent = activeAddonVariant ? formatMoney(activeAddonVariant.price) : '';
      if (addonSubscriptionPrice) addonSubscriptionPrice.textContent = selectedPlan ? formatMoney(selectedPlan.price) : 'Unavailable';
      if (addonPurchaseOptions) {
        addonPurchaseOptions.querySelectorAll('[data-cd-cart-addon-purchase-mode]').forEach(function (input) {
          input.checked = input.value === addonPurchaseMode;
          input.disabled = busyCount > 0 || (input.value === 'subscription' ? !plans.length : requiresPlan);
        });
      }
      if (addonPlanSelect) {
        addonPlanSelect.innerHTML = plans.map(function (plan) {
          return '<option value="' + escapeHtml(plan.id) + '"' + (plan.id === addonSellingPlanId ? ' selected' : '') + '>' + escapeHtml(plan.name) + '</option>';
        }).join('');
        addonPlanSelect.disabled = busyCount > 0 || addonPurchaseMode !== 'subscription' || !plans.length;
      }
      if (addonPlanDetails) {
        var showPlanDetails = addonPurchaseMode === 'subscription' && Boolean(selectedPlan);
        addonPlanDetails.classList.toggle('is-open', showPlanDetails);
        addonPlanDetails.setAttribute('aria-hidden', showPlanDetails ? 'false' : 'true');
        addonPlanDetails.inert = !showPlanDetails;
      }
      if (addonPlanDescription) addonPlanDescription.textContent = selectedPlan ? selectedPlan.description : '';
    }

    function renderAddonVariant() {
      if (!activeAddonProduct) return;
      activeAddonVariant = getSelectedAddonVariant();
      renderAddonPurchaseOptions();
      var selectedPlan = getSelectedAddonPlan();
      var available = Boolean(activeAddonVariant && activeAddonVariant.available && (addonPurchaseMode !== 'subscription' || selectedPlan));
      var image = activeAddonVariant && activeAddonVariant.image ? activeAddonVariant.image : activeAddonProduct.image;
      if (addonImageWrap) {
        addonImageWrap.innerHTML = image
          ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(activeAddonProduct.title) + '">'
          : '';
      }
      if (addonPrice) addonPrice.textContent = activeAddonVariant ? formatMoney(selectedPlan ? selectedPlan.price : activeAddonVariant.price) : '';
      if (addonSubmit) {
        addonSubmit.disabled = busyCount > 0 || !available;
        addonSubmit.textContent = available ? 'Add to cart' : 'Unavailable';
      }
      if (addonAvailability) {
        var bundleOnly = activeAddonVariant && activeAddonVariant.sellingPlans.length && !getStandalonePlans(activeAddonVariant).length;
        addonAvailability.textContent = addonError || (!activeAddonVariant || !activeAddonVariant.available
          ? 'This combination is currently unavailable.'
          : bundleOnly ? 'Subscriptions for this add-on are available only as part of a bundle.'
          : !available ? 'A subscription is required, but no plan is available for this option.' : '');
      }
    }

    function closeAddonModal(options) {
      options = options || {};
      if (!addonModal || addonModal.hidden) return;
      var returnFocus = addonReturnFocus;
      if (!returnFocus || !document.documentElement.contains(returnFocus)) {
        returnFocus = Array.from(root.querySelectorAll('[data-cd-cart-recommendation-product]')).find(function (button) {
          return activeAddonProduct && button.dataset.cdCartRecommendationProduct === activeAddonProduct.id;
        }) || root.querySelector('[data-drawer-close]');
      }
      addonModal.hidden = true;
      addonModal.setAttribute('aria-hidden', 'true');
      activeAddonProduct = null;
      activeAddonVariant = null;
      if (options.returnFocus !== false && returnFocus) {
        returnFocus.focus({ preventScroll: true });
      }
      addonReturnFocus = null;
    }

    function openAddonModal(product, opener) {
      if (!addonModal || !addonOptions || !product) return;
      activeAddonProduct = product;
      addonPurchaseMode = 'one_time';
      addonSellingPlanId = '';
      addonError = '';
      addonReturnFocus = opener || null;
      if (addonTitle) addonTitle.textContent = product.title;
      addonModal.querySelectorAll('[data-cd-cart-addon-product-link]').forEach(function (link) {
        link.setAttribute('href', product.url);
        link.setAttribute('aria-label', 'View ' + product.title);
      });
      if (addonQuantity) addonQuantity.value = '1';

      var cartVariantIds = new Set((currentCart && currentCart.items ? currentCart.items : []).map(function (item) {
        return String(item.variant_id);
      }));
      var firstAvailableVariant = product.variants.find(function (variant) {
        return variant.available && !cartVariantIds.has(variant.id);
      }) || product.variants.find(function (variant) {
        return variant.available;
      }) || product.variants[0];

      addonOptions.hidden = product.hasOnlyDefaultVariant;
      addonOptions.innerHTML = (product.hasOnlyDefaultVariant ? [] : product.options).map(function (option, optionIndex) {
        var selectedValue = firstAvailableVariant && firstAvailableVariant.options[optionIndex];
        var values = (Array.isArray(option.values) ? option.values : []).map(function (value) {
          return '<option value="' + escapeHtml(value) + '"' + (value === selectedValue ? ' selected' : '') + '>' + escapeHtml(value) + '</option>';
        }).join('');
        return '<label><span>' + escapeHtml(option.name) + '</span><select data-cd-cart-addon-option="' + optionIndex + '">' + values + '</select></label>';
      }).join('');

      addonModal.hidden = false;
      addonModal.setAttribute('aria-hidden', 'false');
      renderAddonVariant();
      var firstSelect = addonOptions.querySelector('select');
      window.setTimeout(function () {
        (firstSelect || addonModal.querySelector('[data-cd-cart-addon-close]')).focus({ preventScroll: true });
      }, 0);
    }

    function trapAddonModalFocus(event) {
      if (!addonModal || addonModal.hidden || event.key !== 'Tab') return;
      var focusable = Array.from(addonModal.querySelectorAll('a[href], button:not(:disabled), select:not(:disabled), input:not(:disabled)')).filter(function (control) {
        return control.getClientRects().length > 0;
      });
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    root.addEventListener('click', function (event) {
      var quantityButton = event.target.closest('[data-cd-cart-quantity]');
      if (quantityButton) {
        var itemElement = quantityButton.closest('[data-cd-cart-item-key]');
        var itemKey = itemElement && itemElement.dataset.cdCartItemKey;
        var item = currentCart && currentCart.items.find(function (candidate) { return candidate.key === itemKey; });
        if (!item) return;
        var difference = quantityButton.dataset.cdCartQuantity === 'increase' ? 1 : -1;
        runMutation(function () {
          return changeCartItem(item.key, Math.max(0, Number(item.quantity || 0) + difference));
        });
        return;
      }

      var removeButton = event.target.closest('[data-cd-cart-remove]');
      if (removeButton) {
        var removeItem = removeButton.closest('[data-cd-cart-item-key]');
        var removeKey = removeItem && removeItem.dataset.cdCartItemKey;
        if (removeKey) runMutation(function () { return changeCartItem(removeKey, 0); }, 'Item removed.');
        return;
      }

      var addButton = event.target.closest('[data-cd-cart-recommendation-product]');
      if (addButton) {
        if (suppressRecommendationClick && event.detail !== 0) {
          event.preventDefault();
          return;
        }
        var recommendation = renderedRecommendations.get(addButton.dataset.cdCartRecommendationProduct);
        if (!recommendation) return;
        if (!needsAddonOptions(recommendation)) {
          runMutation(function () { return addCartVariant(recommendation.variants[0].id); }, 'Add-on added.');
        } else {
          openAddonModal(recommendation, addButton);
        }
        return;
      }

      if (event.target.closest('[data-cd-cart-recommendations-previous]')) {
        scrollRecommendations(-1);
        return;
      }
      if (event.target.closest('[data-cd-cart-recommendations-next]')) scrollRecommendations(1);
    }, { signal: signal });

    if (addonModal) {
      addonModal.addEventListener('click', function (event) {
        if (event.target.closest('[data-cd-cart-addon-close]')) closeAddonModal();
      }, { signal: signal });
      addonModal.addEventListener('keydown', trapAddonModalFocus, { signal: signal });
    }

    if (addonOptions) addonOptions.addEventListener('change', function () {
      addonError = '';
      renderAddonVariant();
    }, { signal: signal });
    if (addonPurchaseOptions) addonPurchaseOptions.addEventListener('change', function (event) {
      if (event.target.matches('[data-cd-cart-addon-purchase-mode]')) addonPurchaseMode = event.target.value;
      if (event.target === addonPlanSelect) addonSellingPlanId = addonPlanSelect.value;
      addonError = '';
      renderAddonVariant();
    }, { signal: signal });
    if (addonForm) {
      addonForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (busyCount > 0 || !activeAddonVariant || !activeAddonVariant.available) return;
        var selectedPlan = getSelectedAddonPlan();
        if ((activeAddonVariant.requiresSellingPlan || addonPurchaseMode === 'subscription') && !selectedPlan) return;
        var variantId = activeAddonVariant.id;
        var quantity = Math.max(1, Number(addonQuantity && addonQuantity.value) || 1);
        addonError = '';
        var added = await runMutation(function () {
          return addCartVariant(variantId, null, quantity, selectedPlan && selectedPlan.id);
        }, 'Add-on added.');
        if (added) closeAddonModal();
      }, { signal: signal });
    }

    if (protectionToggle) {
      protectionToggle.addEventListener('change', function () {
        setProtection(protectionToggle.checked);
      }, { signal: signal });
    }

    // FastClick must receive touchstart to clear the previous (cart-opening) tap.
    // Opt the actual target into native clicks instead of blocking the gesture:
    // the scroll lock consumes touchmove, so FastClick cannot distinguish a swipe.
    [root, addonModal].forEach(function (surface) {
      if (!surface) return;
      surface.addEventListener('touchstart', function (event) {
        if (event.target.classList) event.target.classList.add('needsclick');
      }, { passive: true, signal: signal });
    });

    if (recommendationsTrack) {
      recommendationsTrack.addEventListener('pointerdown', function (event) {
        suppressRecommendationClick = false;
        recommendationGesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, { passive: true, signal: signal });
      recommendationsTrack.addEventListener('pointermove', function (event) {
        if (!recommendationGesture || recommendationGesture.id !== event.pointerId) return;
        if (Math.abs(event.clientX - recommendationGesture.x) > 10 || Math.abs(event.clientY - recommendationGesture.y) > 10) {
          suppressRecommendationClick = true;
        }
      }, { passive: true, signal: signal });
      recommendationsTrack.addEventListener('pointercancel', function () {
        suppressRecommendationClick = true;
        recommendationGesture = null;
      }, { passive: true, signal: signal });
      recommendationsTrack.addEventListener('pointerup', function () {
        recommendationGesture = null;
      }, { passive: true, signal: signal });
      recommendationsTrack.addEventListener('scroll', function () {
        if (recommendationGesture) suppressRecommendationClick = true;
        updateRecommendationControls();
      }, { passive: true, signal: signal });
    }
    window.addEventListener('resize', updateRecommendationControls, { signal: signal });

    ['cart:change', 'cart:updated', 'cart:refresh', 'theme:cart:change', 'ajaxProduct:added'].forEach(function (eventName) {
      document.addEventListener(eventName, function () { requestRefresh(true); }, { signal: signal });
    });

    return {
      refresh: requestRefresh,
      closeModal: closeAddonModal,
      isModalOpen: function () { return Boolean(addonModal && !addonModal.hidden); },
      destroy: function () {
        window.clearTimeout(refreshTimer);
        abortController.abort();
        if (addonModal && addonModal.parentNode) addonModal.remove();
      }
    };
  }

  function initialize() {
    initializationQueued = false;
    var root = document.querySelector('[data-cd-cart-drawer]');
    if (!root || (activeController && root.dataset.cdCartReady === 'true')) {
      syncPageScroll();
      return;
    }

    if (activeController) activeController.destroy();
    activeController = createController(root);
    activeController.refresh(false);
    syncPageScroll();
  }

  function queueInitialization() {
    if (initializationQueued) return;
    initializationQueued = true;
    window.requestAnimationFrame(initialize);
  }

  document.addEventListener('wheel', containPointerScroll, { capture: true, passive: false });
  document.addEventListener('touchmove', containPointerScroll, { capture: true, passive: false });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeController && activeController.isModalOpen()) {
      event.preventDefault();
      activeController.closeModal();
      return;
    }
    if (event.key === 'Escape') {
      var drawer = getOpenDrawer();
      var closeButton = drawer && drawer.querySelector('[data-drawer-close]');
      if (closeButton) closeButton.click();
    }
    containKeyboardScroll(event);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueInitialization, { once: true });
  } else {
    queueInitialization();
  }

  var drawerHost = document.getElementById('t4s-mini_cart');
  if (drawerHost) {
    new MutationObserver(function () {
      queueInitialization();
      syncPageScroll();
    }).observe(drawerHost, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }
})();
